'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const isSurveyGroupItemResponse = (item) => {
    const items = item.items;
    return items !== undefined && items.length > 0;
};

exports.isSurveyGroupItemResponse = isSurveyGroupItemResponse;
//# sourceMappingURL=response.js.map
